/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.tabs.init());

// We're using Bootstrap's interface on the UI side, but rolling our own
// js because theirs was buggy, sometimes not activating the tab on first click.

App.tabs = {
  init() {
    return $(document)
      .off("click", "[data-toggle=tab], [data-toggle=pill]", App.tabs.clicked)
      .on("click", "[data-toggle=tab], [data-toggle=pill]", App.tabs.clicked);
  },

  clicked(evt) {
    evt.preventDefault();
    const $trigger     = $(this);
    const $new_tab     = $($trigger.attr("href") || $trigger.attr("data-target"));
    const $current_tab = $new_tab.closest(".tab-content").find("> .tab-pane.active:first");

    // Deactivate all triggers
    $trigger.closest(".nav, .tabs").find("li, .tab-btn").removeClass("active");

    // Highlight the clicked trigger
    $trigger.closest("li, .tab-btn").addClass("active");

    // In case trigger is a link with an LI parent, add to parent too
    $trigger.parent("li").addClass("active");

    // Fade out current tab,
    $current_tab.removeClass("in");

    // Then deactivate current tab,
    $current_tab.removeClass("active");

    // Then fade in and activate clicked tab at once
    $new_tab.addClass("active in");

    // If there's a radio inside the trigger, check it
    // This is necessary because we stop default propagation
    return $trigger.find("> input[type='radio']").prop("checked", true);
  }
};
